import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45a98780"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plan" }
const _hoisted_2 = { class: "plan__title" }
const _hoisted_3 = { class: "plan__title-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "plan__title-name" }, "Your Plan", -1))
const _hoisted_5 = { class: "plan__title-content" }
const _hoisted_6 = { class: "plan__title-btn btns btns btns--font-large" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Reactivate ", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Switch to Monthly ", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "subscription-error"
}
const _hoisted_12 = { class: "plan-details-annual" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "plan-details-title plan-details-title--annual" }, "Details", -1))
const _hoisted_14 = { class: "plan-details-annual__top" }
const _hoisted_15 = { class: "plan-details-annual__top-left" }
const _hoisted_16 = { class: "plan-details-name" }
const _hoisted_17 = { class: "plan-details-annual__top-right" }
const _hoisted_18 = {
  key: 0,
  class: "plan-details-annual__top-right-text plan-details__top-right-text--discount"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ($0 for 3mo, then $16.42/mo) ", -1))
const _hoisted_20 = {
  key: 1,
  class: "plan-details-annual__top-right-text"
}

import { ref } from 'vue'
import { useWait } from '@/app/composables/useWait'
import { BillingView } from '@/models/billing'

import PlanDate from './BillingDataPaid.PlanDate.vue'
import { PlanChangeFailedError } from '@/services/cordova.purchase.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingDataPaid.PlanInfo.Annual',
  props: {
    billing: null
  },
  emits: ['subscribed'],
  setup(__props: any, { emit }) {

const props = __props as {
  billing: BillingView
};



const wait = useWait()


const error = ref<string | null>(null)

async function switchMonthlyDirectly(): Promise<void> {
  error.value = null
  try {
    wait.start('Subscribing')
    await props.billing.subscribeTo(props.billing.monthlyPlan)
    emit('subscribed')
    wait.end('Subscribing')
  } catch (err) {
    if (err instanceof PlanChangeFailedError) {
      error.value = err.message
    }
    wait.end('Subscribing')
  }
}

async function reactivate(): Promise<void> {
  try {
    wait.start('Subscribing')
    await props.billing.subscribeTo(props.billing.plan)
    emit('subscribed')
    wait.end('Subscribing')
  } catch (error) {
    wait.end('Subscribing')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_button_spinner = _resolveComponent("button-spinner")!
  const _component_v_wait = _resolveComponent("v-wait")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h2", _hoisted_5, _toDisplayString(__props.billing.planName), 1)
      ]),
      _createElementVNode("div", null, [
        (__props.billing.allowPlanChange)
          ? (_openBlock(), _createBlock(_component_v_wait, {
              key: 0,
              for: "Subscribing"
            }, {
              waiting: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, [
                  _createTextVNode(" Processing... "),
                  _createVNode(_component_button_spinner)
                ])
              ]),
              default: _withCtx(() => [
                (
              __props.billing.cancel_at_period_end || __props.billing.change_plan_at_period_end
            )
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "plan__title-btn btns btns btns--font-large",
                      onClick: reactivate
                    }, _hoisted_8))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "plan__title-btn btns btns--white btns--font-large",
                      onClick: switchMonthlyDirectly
                    }, _hoisted_10))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (error.value !== null && error.value !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(error.value), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("p", _hoisted_16, _toDisplayString(__props.billing.plan.nickname) + " Plan", 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          (__props.billing.showPricesAfterDiscount)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                _createTextVNode(" $147.75/yr "),
                _hoisted_19
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(__props.billing.currentPeriodPrice.withPeriod.perYear), 1))
        ])
      ])
    ]),
    _createVNode(PlanDate, { billing: __props.billing }, null, 8, ["billing"])
  ]))
}
}

})